import { Injectable } from '@angular/core';
import { AuthRequest, AuthResult, AuthStatusType } from '../model/auth.model';
import { FamsHelperService } from './fams-helper.service';
import { ConfigurationService } from '../../../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationHelperService {
  windowVar = window as any;
  constructor(private readonly famsHelperService: FamsHelperService) {}

  handleReauthenticationResponse(request: AuthRequest) {
    if (this.windowVar.app?.features?.isFAMSEnabled) {
      this.famsHelperService.handleReauthenticationResponse(request);
    }
  }

  reauth(publishCallback: () => void, errorCallBack: () => void): void {
    if (!ConfigurationService.isLimsHosted) {
      publishCallback();
      return;
    }
    (window as any).Master?.oidcTokenManager?.checkFamsAndGetWindowPopupForReauth();
    const request = {
      successCallback: (authResult: AuthResult) => {
        if (authResult && authResult.status === AuthStatusType.Success && authResult.token) {
          publishCallback();
        }
        else{
          errorCallBack();
        }
      },
      messageForUnauthorizedCredentials: $localize`:@@TransitionInvalidCredentials:Credentials are incorrect and the status update was not successful.`
    };
    this.handleReauthenticationResponse(request);
  }
}
